export enum BonusTriggerType {
  DEPOSIT_BY_CODE = 1,
  DEPOSIT_BY_CLICK,
  GAMIFICATION,
  BY_BUNDLE,
  BY_CODE,
  BY_REGISTRATION,
  MANUAL,
}
